import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Award } from "lucide-react";
import { getEmployeeAwardList } from "../../../../../redux/employeeaward/employeeAwardState";
import dayjs from "dayjs";

const AwardCardCompact = ({ recordList, pagination, doSearch }) => {
  useEffect(() => {
    doSearch({ paginate: pagination.per_page });
  }, [doSearch, pagination.per_page]);

  const awards = recordList
    ?.filter((item) => item?.ema_status_id === 1)
    ?.map((item) => ({
      initials: item?.employee_name
        ?.split(" ")
        .map((n) => n[0])
        .join("") || "-",
      name: item?.employee_name || "-",
      role: item?.employee_position || "-",
      awardName: item?.award_title || "-",
      awardDate: item?.ema_issued_at
        ? dayjs(item.ema_issued_at).format("MMMM YYYY")
        : "-",
      theme: item?.award_color_class,
      description: item?.ema_feedback || "-",
    }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {awards.map((award) => (
        <div
          key={award.id}
          className="flex flex-col gap-4 rounded-xl border-2 border-slate-200 dark:border-slate-700 hover:shadow-lg transition-all duration-300 h-full nomination"
        >
          <div className="p-4 [&:last-child]:pb-6">

            <div className="flex items-start gap-3 mb-3">
             <div
                className={`w-12 h-12 rounded-full p-2 bg-text gradient-purple flex items-center justify-center flex-shrink-0`}
              >
                <span className="text-white text-sm font-semibold">
                  {award.initials}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-[14px] truncate mb-0.5 font-semibold title-text">
                  {award.name}
                </h4>
                <p className="text-[11px] truncate muted-text">
                  {award.role}
                </p>
              </div>
            </div>

            <div
              className={`p-3 rounded-lg mb-3 icon-style ${award.theme}`}
            >
              <div className="flex items-center gap-2 mb-1 text-white">
                <Award className="w-4 h-4 " />
                <p className="text-[12px] font-semibold">
                  {award.awardName}
                </p>
              </div>
              <p className="text-[10px] text-white">{award.awardDate}</p>
            </div>

            <p className="text-[12px] line-clamp-2 leading-relaxed muted-text">
              {award.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardCardCompact);